import { render, staticRenderFns } from "./BannerModal.vue?vue&type=template&id=046fc33e&"
import script from "./BannerModal.vue?vue&type=script&lang=ts&"
export * from "./BannerModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('046fc33e')) {
      api.createRecord('046fc33e', component.options)
    } else {
      api.reload('046fc33e', component.options)
    }
    module.hot.accept("./BannerModal.vue?vue&type=template&id=046fc33e&", function () {
      api.rerender('046fc33e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/banner/components/BannerModal.vue"
export default component.exports